"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabEnd = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TabContext_1 = require("./TabContext");
const lib_1 = require("../../lib");
const TabEnd = ({ children }) => {
    const { state, compact } = (0, react_1.useContext)(TabContext_1.TabContext);
    if (state.searchTerm !== undefined)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.bem)('tabs__tab-end', (0, lib_1.use)(compact, '--compact')) }, { children: children }), void 0));
};
exports.TabEnd = TabEnd;
//# sourceMappingURL=TabEnd.js.map